// import React, { useState } from 'react'
// import {
// 	Button,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions
// } from '@material-ui/core'
// import Selection from 'screens/Selection/Selection'
// import { makeStyles, useTheme } from '@material-ui/core/styles'
// import Options from 'screens/Selection/Options'
// import { Add as PlusIcon } from '@material-ui/icons'
// const useStyles = makeStyles(() => ({
// 	noScroll: {
// 		overflowY: 'scroll',
// 		scrollbarWidth: 'none',
// 		'-ms-overflow-style': 'none',
// 		'&::-webkit-scrollbar': {
// 			display: 'none'
// 		}
// 	}
// }))

// const AddButton = ({ refreshData }) => {
// 	const [open, setOpen] = useState(false)
// 	const classes = useStyles()
// 	const handleOpen = () => setOpen(true)
// 	const handleClose = () => setOpen(false)

// 	return (
// 		<>
// 			<Button variant="contained" onClick={handleOpen} style={{ textTransform: 'none' }}>
// 				<PlusIcon sx={{ mr: 0.5 }} />
// 				Add Question(s)
// 			</Button>

// 			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
// 				<DialogTitle>Add New Question</DialogTitle>

// 				<DialogContent className={classes.noScroll}>
// 					{/* <Selection handleClose={handleClose} refreshData={refreshData} /> */}
// 					<Options handleClose={handleClose} refreshData={refreshData} />
// 				</DialogContent>
// 			</Dialog>
// 		</>
// 	)
// }

// export default AddButton

import React, { useState } from 'react'
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Close as CloseIcon, Add as PlusIcon } from '@material-ui/icons'
import Options from 'screens/Selection/Options'

const useStyles = makeStyles(() => ({
	noScroll: {
		overflowY: 'scroll',
		scrollbarWidth: 'none',
		'-ms-overflow-style': 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},
	dialogTitle: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingRight: '16px'
	}
}))

const AddButton = ({ refreshData }) => {
	const [open, setOpen] = useState(false)
	const classes = useStyles()

	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)

	return (
		<>
			<Button variant="contained" onClick={handleOpen} style={{ textTransform: 'none' }}>
				<PlusIcon style={{ marginRight: 4 }} />
				Add Question(s)
			</Button>

			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
				<DialogTitle
					// className={classes.dialogTitle}
					disableTypography
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: 'rgb(125, 110, 241)',
						height: '50px',
						color: 'white',
						padding: '0 16px'
					}}
				>
					<h2 style={{ margin: 0, fontSize: '1.25rem' }}>Add New Question(s)</h2>
					{/* <IconButton onClick={handleClose} style={{ marginRight: '-18px' }}> */}
					<CloseIcon style={{ color: 'white', cursor: 'pointer' }} onClick={handleClose} />
					{/* </IconButton> */}
				</DialogTitle>

				<DialogContent className={classes.noScroll}>
					<Options handleClose={handleClose} refreshData={refreshData} />
				</DialogContent>
			</Dialog>
		</>
	)
}

export default AddButton
